import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useAllFilterBaseContext } from "../../../Context/AllFilterBaseContext";
import { titlevalidation } from "../commonvalidation";

export default function OTSSearch({ placeholder, state, setSearch }) {
  const { clearAllFilterFields } = useAllFilterBaseContext();

  const [showError, setShowError] = useState(false);

  const formik = useFormik({
    initialValues: {
      search: state?.search || "",
    },
    validationSchema: Yup.object({
      search: titlevalidation
        .trim()
        .required("Please enter something to search"),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: (values) => {

      if (formik?.values?.search?.length > 0) {
        setSearch(values.search);
        window.scrollTo(0, 450);
      }

    },
  });

  // Show validation error only for 2 seconds
  useEffect(() => {
    if (formik.errors.search) {
      setShowError(true);
      // const timer = setTimeout(() => {
      //   setShowError(false);
      // }, 2000);
      // return () => clearTimeout(timer);
    }
  }, [formik.errors.search]);

  useEffect(() => {
    if (formik?.values?.search?.length > 0) {
      setShowError(false);
    }
    else {
      setShowError(true);
    }
  }, [formik?.values?.search]);

  // ❌ Do not run validation on clear button
  const handleClearAndSubmit = () => {
    formik.setFieldValue("search", "", false);

    clearAllFilterFields();

    // Hide any existing error message
    setShowError(false);
  };

  return (
    <div className="search-bar w-100">
      {/* {JSON.stringify(formik.errors)}
      {JSON.stringify(formik.values)} */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.submitForm(); // Only Search button triggers validation
        }}
        className="w-100"
      >
        <div className="position-relative w-100">
          <input
            id="search"
            name="search"
            type="text"
            placeholder={placeholder}
            className="form-control"
            onChange={formik.handleChange}
            value={formik.values.search}
          />

          {/* Clear button — no validation */}
          {formik.values.search.length > 0 && (
            <button
              type="button"
              className="search-close"
              onClick={handleClearAndSubmit}
            >
              &#x2715;
            </button>
          )}

          {/* Search button — triggers validation */}
          <button className="btn search-btn" type="submit">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
              alt="Search"
            />
          </button>
        </div>

        {/* Error message (2 seconds only) */}
        {showError && formik.errors.search && (
          <div className="text-danger mt-1">{formik.errors.search}</div>
        )}
      </form>
    </div>
  );
}
